module.exports = "<np-header-bar></np-header-bar> <ui-view></ui-view>";